// Call status values from backend
export const BE_CALL_ALERTING = 'callAlerting';
export const BE_CALL_ANSWERED = 'callAnswered';
export const BE_HOLD_CALL = 'holdCall';
export const BE_END_CALL = 'endCall';
export const BE_RETRIEVE_CALL = 'retrieveCall';

// Call status display names on the frontend
export const FE_RINGING = 'ringing';
export const FE_ANSWERED = 'answered';
export const FE_ON_HOLD = 'on hold';
export const FE_RELEASED = 'released';
